import slugify from '$utils/slugify';

/** @type {import('./$types').PageLoad} */
export async function load({ params, parent }) {
  const { posts } = await parent();
  const post = posts.find((post) => slugify(post.slugTitle) === params.slug);
  return {
    slug: params.slug,
    post,
  };
}
